export const loadAdSenseScript = () => {
  const scriptId = "adsense-script";

  if (document.getElementById(scriptId)) return;

  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1652736932683327";
  script.crossOrigin = "anonymous";

  document.head.appendChild(script);
};
